import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getUserProfile } from '@/api'

export const useUserStore = defineStore('user', () => {
  const token = ref(uni.getStorageSync('token') || '')
  const profile = ref(null)

  function setToken(val) {
    token.value = val
    uni.setStorageSync('token', val)
  }

  function clearAuth() {
    token.value = ''
    profile.value = null
    uni.removeStorageSync('token')
  }

  async function fetchProfile() {
    try {
      const res = await getUserProfile()
      if (res.code === 200) {
        profile.value = res.data
      }
      return res
    } catch (e) {
      return null
    }
  }

  function syncTokenFromStorage() {
    const stored = uni.getStorageSync('token') || ''
    if (stored !== token.value) {
      token.value = stored
    }
    return stored
  }

  // 小程序 reLaunch 不会重启 Pinia，登录态以 storage 为准
  const isLoggedIn = () => !!syncTokenFromStorage()

  return { token, profile, setToken, clearAuth, fetchProfile, isLoggedIn, syncTokenFromStorage }
})
